(function() {
  if (window._wlDone) return;
  window._wlDone = true;

  var WL = window.Wishlist = {
    key: "xendaba_wishlist",
    getAll: function() { try { return JSON.parse(localStorage.getItem(this.key)) || []; } catch(e) { return []; } },
    has: function(id) { var a = this.getAll(); for (var i = 0; i < a.length; i++) if (a[i].id == id) return true; return false; },
    add: function(p) { var a = this.getAll(); for (var i = 0; i < a.length; i++) if (a[i].id == p.id) return; a.push(p); localStorage.setItem(this.key, JSON.stringify(a)); this.updateBadge(); },
    remove: function(id) { var a = this.getAll(), b = []; for (var i = 0; i < a.length; i++) if (a[i].id != id) b.push(a[i]); localStorage.setItem(this.key, JSON.stringify(b)); this.updateBadge(); },
    toggle: function(p) { if (this.has(p.id)) { this.remove(p.id); return false; } this.add(p); return true; },
    updateBadge: function() { var c = this.getAll().length, e = document.querySelectorAll(".wishlist-count"); for (var i = 0; i < e.length; i++) { e[i].textContent = c; e[i].style.display = c > 0 ? "flex" : "none"; } },

    syncCards: function() {
      var btns = document.querySelectorAll("[data-wishlist-btn]");
      for (var i = 0; i < btns.length; i++) {
        var handle = btns[i].getAttribute("data-product-handle");
        if (!handle) continue;
        var on = this.has(handle);
        var svg = btns[i].querySelector("svg");
        if (svg) { svg.style.fill = on ? "#ef4444" : "none"; svg.style.stroke = on ? "#ef4444" : "#666"; }
      }
    },

    injectProductPage: function() {
      if (window.location.pathname.indexOf("/products/") === -1) return;
      if (document.querySelector(".wl-pbtn")) return;
      var ph = window.location.pathname.split("/products/")[1];
      if (!ph) return;
      ph = ph.split("?")[0].split("#")[0];
      var pt = document.querySelector("h1");
      var pi = document.querySelector(".product__media img");
      var pb = document.querySelector(".product-form__buttons");
      if (!pb) return;
      var self = this;
      var active = self.has(ph);
      var btn = document.createElement("button");
      btn.className = "wl-pbtn button button--full-width button--secondary";
      btn.type = "button";
      btn.style.cssText = "display:inline-flex;align-items:center;justify-content:center;gap:8px;margin-top:10px;";
      var svgFill = active ? "#ef4444" : "none";
      var svgStroke = active ? "#ef4444" : "currentColor";
      btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="' + svgFill + '" stroke="' + svgStroke + '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg><span>' + (active ? "Favorilerde" : "Favorilere Ekle") + '</span>';
      (function(h, t, im) {
        btn.addEventListener("click", function(e) {
          e.preventDefault();
          var added = self.toggle({ id: h, title: t ? t.textContent.replace(/^\s+|\s+$/g, "") : "", url: "/products/" + h, image: im ? im.getAttribute("src") : "", handle: h });
          var svg = this.querySelector("svg");
          svg.style.fill = added ? "#ef4444" : "none";
          svg.style.stroke = added ? "#ef4444" : "currentColor";
          this.querySelector("span").textContent = added ? "Favorilerde" : "Favorilere Ekle";
          self.syncCards();
        });
      })(ph, pt, pi);
      pb.parentNode.insertBefore(btn, pb.nextSibling);
    },

    renderList: function(id) {
      var el = document.getElementById(id); if (!el) return;
      var list = this.getAll();
      if (!list.length) { el.innerHTML = '<p style="text-align:center;color:#999;padding:2rem;">Hen\u00fcz favoriniz yok.</p>'; return; }
      var h = '<div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(160px,1fr));gap:16px;">';
      for (var i = 0; i < list.length; i++) {
        var p = list[i];
        h += '<div style="border:1px solid #e5e5e5;border-radius:10px;overflow:hidden;background:#fff;">'
          + '<a href="' + p.url + '" style="display:flex;align-items:center;justify-content:center;aspect-ratio:1;overflow:hidden;background:#fff;">'
          + '<img src="' + (p.image || "") + '" style="max-width:100%;max-height:100%;object-fit:contain;" loading="lazy">'
          + '</a>'
          + '<div style="padding:10px;">'
          + '<a href="' + p.url + '" style="font-size:12px;font-weight:500;color:#333;text-decoration:none;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;">' + (p.title || "") + '</a>'
          + '<div style="margin-top:8px;display:flex;gap:4px;">'
          + "<button onclick=\"Wishlist.addToCart('" + p.handle + "')\" style=\"flex:1;padding:6px;background:#1a1a2e;color:#fff;border:none;border-radius:6px;font-size:11px;cursor:pointer;\">Sepete Ekle</button>"
          + "<button onclick=\"Wishlist.remove('" + p.id + "');Wishlist.renderList('" + id + "');\" style=\"padding:6px 8px;background:#fff;border:1px solid #ddd;border-radius:6px;cursor:pointer;font-size:12px;\">&#10005;</button>"
          + '</div></div></div>';
      }
      el.innerHTML = h + '</div>';
    },

    addToCart: function(handle) {
      fetch("/products/" + handle + ".js").then(function(r) { return r.json(); }).then(function(p) { return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: [{ id: p.variants[0].id, quantity: 1 }] }) }); }).then(function() { window.location.href = "/cart"; }).catch(function() { alert("Sepete eklenemedi"); });
    }
  };

  /* CAPTURE PHASE: kart linkinden ONCE yakala — tum sayfalarda calisir */
  document.addEventListener("click", function(e) {
    var btn = e.target.closest("[data-wishlist-btn]");
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var d = btn.dataset;
    var handle = d.productHandle;
    if (!handle) return;
    var added = WL.toggle({
      id: handle,
      title: d.productTitle || "",
      url: d.productUrl || "/products/" + handle,
      image: d.productImage || "",
      handle: handle,
      price: d.productPrice || ""
    });
    var svg = btn.querySelector("svg");
    if (svg) {
      svg.style.fill = added ? "#ef4444" : "none";
      svg.style.stroke = added ? "#ef4444" : "#666";
    }
  }, true);

  function wlStart() {
    WL.updateBadge();
    WL.syncCards();
    WL.injectProductPage();
    WL.renderList("wishlist-container");
    WL.renderList("cart-wishlist");
  }

  if (document.readyState === "complete" || document.readyState === "interactive") { wlStart(); }
  else { document.addEventListener("DOMContentLoaded", wlStart); }
  setTimeout(wlStart, 2000);

  var _t = null;
  new MutationObserver(function() { if (_t) clearTimeout(_t); _t = setTimeout(function() { WL.syncCards(); }, 300); }).observe(document.body, { childList: true, subtree: true });
})();